<template>
  <Layout :is-loading="isLoading">
    <div class="bloco">
      <HeaderPage :page-titles="pageTitles" :hide-button="true" />

      <div>
        <b-tabs content-class="mt-3">
          <b-tab title="Equipamentos ociosos" @click="page = 1">
            <fieldset class="form-group">
              Por página:
              <select
                v-model="perPage"
                class="d-inline-block w-auto custom-select custom-select-sm"
                name="value"
                @change="page = 1"
              >
                <option v-for="value in perPages" :key="value">
                  {{ value }}
                </option>
              </select>
            </fieldset>
            <b-table
              striped
              hover
              responsive
              borderless
              bordered
              outlined
              small
              :items="equipments"
              :fields="fields"
              :per-page="perPage"
              :current-page="page"
              show-empty
              empty-text="Não há registros no momento"
              class="table-vertical-scroll"
            >
              <template v-slot:cell(unitary_value)="row">
                <span>{{
                  row.item.unitary_value.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  }) ||
                    '0'.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })
                }}</span>
              </template>
              <template v-slot:cell(options)="row">
                <b-button
                  v-b-tooltip.hover
                  title="Adiar lembrete"
                  size="sm"
                  variant="light"
                  @click="modalCreateAdiamento(row.item)"
                >
                  <b-icon-clock-history />
                </b-button>
              </template>
            </b-table>
            <div class="d-flex justify-content-between">
              <p class="text-left" style="color: #a3a4a6">
                Página {{ page }} de
                {{
                  Math.ceil(equipments.length / perPage) > 0
                    ? Math.ceil(equipments.length / perPage)
                    : 1
                }}
              </p>
              <div class="text-right">
                <b-pagination
                  v-if="equipments.length > perPage"
                  v-model="page"
                  size="md"
                  :total-rows="equipments.length"
                  :per-page="perPage"
                />
              </div>
            </div>
          </b-tab>
          <b-tab title="Equipamentos necessários" @click="page = 1">
            <fieldset class="form-group">
              Por página:
              <select
                v-model="perPage"
                class="d-inline-block w-auto custom-select custom-select-sm"
                name="value"
                @change="page = 1"
              >
                <option v-for="value in perPages" :key="value">
                  {{ value }}
                </option>
              </select>
            </fieldset>
            <b-table
              striped
              hover
              responsive
              borderless
              bordered
              outlined
              small
              :items="equipmentsNecessaries"
              :fields="fieldsNecessaries"
              :per-page="perPage"
              :current-page="page"
              sort-by="equipment.insumo"
              show-empty
              empty-text="Não há registros no momento"
              class="table-vertical-scroll"
            >
              <template v-slot:cell(unitary_value)="row">
                <span>{{
                  row.item.unitary_value.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  }) ||
                    '0'.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })
                }}</span>
              </template>
            </b-table>
            <div class="d-flex justify-content-between">
              <p class="text-left" style="color: #a3a4a6">
                Página {{ page }} de
                {{
                  Math.ceil(equipmentsNecessaries.length / perPage) > 0
                    ? Math.ceil(equipmentsNecessaries.length / perPage)
                    : 1
                }}
              </p>
              <div class="text-right">
                <b-pagination
                  v-if="equipmentsNecessaries.length > perPage"
                  v-model="page"
                  size="md"
                  :total-rows="equipmentsNecessaries.length"
                  :per-page="perPage"
                />
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <b-modal v-model="modalOpenAdiamento" title="Criar adiamento" hide-footer>
      <p class="my-2 mb-4">
        Você está criando um adiamento para o patrimônio
        <b class="font-weight-bold"> {{ equipmentSelected.patrimony }}</b
        >, equipamento
        <b class="font-weight-bold">
          {{
            equipmentSelected.insumo.descricao_pai
              ? `${equipmentSelected.insumo.descricao_pai} - ${
                  equipmentSelected.insumo.descricao
                }`
              : `${equipmentSelected.insumo.descricao}`
          }}</b
        >.
      </p>
      <b-form @submit.prevent="saveAdiamento">
        <b-form-group
          label="Adiar até o dia"
          label-for="date"
          label-class="font-weight-bold"
          class="mb-0"
        >
          <b-input
            id="date"
            v-model="adiamento.date"
            type="date"
            required
            class="w-100"
          />
        </b-form-group>
        <div class="d-flex justify-content-end">
          <b-button
            type="submit"
            variant="primary"
            class="mt-5"
            :disabled="!adiamento.date"
          >
            Salvar
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </Layout>
</template>

<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'
import alertMixin from '@/src/mixins/alertMixin'
import EquipmentService from '@/src/services/equipment-service'

export default {
  components: { Layout, HeaderPage },
  mixins: [alertMixin],
  data() {
    return {
      subtotal: null,
      filial: this.$store.state.filial,
      pageTitles: {
        title: 'Equipamentos Ociosos / Necessários',
        subtitle:
          'Verificação de equipamentos ociosos por mais de 7 (sete) dias e equipamentos que estão ociosos, porém foram marcados como necessários',
      },
      equipments: [],
      equipmentsNecessaries: [],
      fields: [
        {
          key: 'insumo.codigo',
          label: 'Código',
          formatter: (value) => {
            if (value.$numberDecimal) {
              return value.$numberDecimal
            } else {
              return value
            }
          },
        },
        {
          key: 'insumo',
          label: 'Equipamento',
          formatter: (value) => {
            return value.descricao_pai
              ? `${value.descricao_pai} - ${value.descricao}`
              : `${value.descricao}`
          },
          thStyle: { width: '20%' },
        },
        {
          key: 'patrimony',
          label: 'Patrimônio',
        },
        {
          key: 'unitary_value',
          label: 'Valor Unitário',
        },
        {
          key: 'lastReturn',
          label: 'Último Uso',
          formatter: (value) => {
            if (value) {
              return this.parseDate(value)
            } else {
              return 'Não há registro'
            }
          },
        },
        {
          key: 'accessories',
          label: 'Acessórios',
          formatter: (value) => {
            return (
              String(value)
                .charAt(0)
                .toUpperCase() +
              String(value)
                .replaceAll(',', ', ')
                .slice(1)
            )
          },
        },
        {
          key: 'operating',
          label: 'Funcionando',
          formatter: (value) => {
            return value ? 'Sim' : 'Não'
          },
        },
        {
          key: 'inUse',
          label: 'Em Uso',
          formatter: (value) => {
            return value ? 'Sim' : 'Não'
          },
        },
        {
          key: 'options',
          label: 'Opções',
          class: 'text-center',
        },
      ],
      fieldsNecessaries: [
        {
          key: 'equipment.insumo.codigo',
          label: 'Código',
          sortable: true,
          sortDirection: 'desc',
        },
        {
          key: 'equipment.insumo',
          label: 'Equipamento',
          formatter: (value) => {
            return value.descricao_pai
              ? `${value.descricao_pai} - ${value.descricao}`
              : `${value.descricao}`
          },
          thStyle: { width: '20%' },
          sortable: true,
        },
        {
          key: 'equipment.patrimony',
          label: 'Patrimônio',
          sortable: true,
        },
        {
          key: 'equipment.unitary_value',
          label: 'Valor Unitário',
          formatter: (value) => {
            return value.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })
          },
          sortable: true,
        },
        {
          key: 'operating',
          label: 'Funcionando',
          formatter: (value) => {
            return value ? 'Sim' : 'Não'
          },
          sortable: true,
        },
        {
          key: 'userRegister.nome',
          label: 'Usuário',
          thStyle: { width: '20%' },
          sortable: true,
        },
        {
          key: 'createdAt',
          label: 'Data do adiamento',
          formatter: (value) => {
            if (value) {
              return this.parseDate(value)
            } else {
              return 'Não há registro'
            }
          },
          sortable: true,
        },
        {
          key: 'dayLimit',
          label: 'Fim do adiamento',
          formatter: (value) => {
            if (value) {
              return this.parseDate(value)
            } else {
              return 'Não há registro'
            }
          },
          sortable: true,
        },
      ],
      page: 1,
      perPage: 10,
      perPages: [10, 25, 50, 100],
      rows: 0,
      isLoading: false,
      modalOpenAdiamento: false,
      equipmentSelected: {
        insumo: '',
      },
      adiamento: {
        date: '',
      },
    }
  },
  watch: {
    filial(value) {
      this.updateByFiliais()
    },
  },
  async created() {
    this.loadIdleEquipments({
      filial: this.$store.state.filial ? this.$store.state.filial : '',
    })
    this.loadEquipmentsNecessaries({
      filial: this.$store.state.filial ? this.$store.state.filial : '',
    })
  },
  methods: {
    async saveAdiamento() {
      const payload = {
        equipment: this.equipmentSelected._id,
        dayLimit: this.adiamento.date,
      }

      try {
        this.isLoading = true
        await EquipmentService.createEquipmentNecessary(payload)

        this.successMessage('Adiamento criado com sucesso')
        this.modalOpenAdiamento = false
      } catch (error) {
        this.errorMessage(
          `Erro ao criar adiamento: ${error.response.data.error.message}`
        )
      } finally {
        await this.loadIdleEquipments()
        await this.loadEquipmentsNecessaries()
        this.isLoading = false
      }
    },
    modalCreateAdiamento(item) {
      this.equipmentSelected = item
      this.adiamento.date = ''

      this.modalOpenAdiamento = true
    },
    updateByFiliais() {
      this.filial = this.$store.state.filial
      this.loadEquipmentsNecessaries()
      this.loadIdleEquipments()
    },
    parseDate(date) {
      if (!date) return null

      const [onlyDate] = date.split('T')

      return onlyDate
        .split('-')
        .reverse()
        .join('/')
    },
    async loadIdleEquipments() {
      try {
        this.isLoading = true
        const { data } = await EquipmentService.loadIdleEquipments({
          filial: this.filial,
        })

        this.equipments = data.sort((a, b) => {
          if (a.insumo.descricao < b.insumo.descricao) {
            return -1
          }
          if (a.insumo.descricao > b.insumo.descricao) {
            return 1
          }
          return 0
        })
      } catch (error) {
        console.log('error', error)
        this.errorMessage(
          `Erro ao carregar os Equipamentos Ociosos: ${
            error.response.data.error.message
          }`
        )
      } finally {
        this.isLoading = false
      }
    },
    async loadEquipmentsNecessaries() {
      try {
        this.isLoading = true
        const data = await EquipmentService.loadEquipmentsNecessaries({
          filial: this.filial,
        })

        this.equipmentsNecessaries = data.data.sort((a, b) => {
          if (a.equipment.insumo.descricao < b.equipment.insumo.descricao) {
            return -1
          }
          if (a.equipment.insumo.descricao > b.equipment.insumo.descricao) {
            return 1
          }
          return 0
        })
      } catch (error) {
        console.log('error', error)
        this.errorMessage(
          `Erro ao carregar os Equipamentos Necessários: ${
            error.response.data.error.message
          }`
        )
      } finally {
        this.isLoading = false
      }
    },
    closeEquipmentFormModal() {
      this.$bvModal.hide('equipment-form-modal')
    },
    async save(formData) {
      this.isLoading = true
      try {
        this.page = 1
        let data = {}
        const equipmentId = formData.get('_id')

        if (!equipmentId) {
          data = await EquipmentService.create(formData)

          this.equipments.push(data)
        }

        if (equipmentId) {
          data = await EquipmentService.update({
            _id: equipmentId,
            equipment: formData,
          })

          const index = this.equipments.findIndex(
            (equipment) => equipment._id === equipmentId
          )

          this.equipments[index] = data
        }

        this.successMessage('Salvo com sucesso')
        this.closeEquipmentFormModal()
        await this.loadEquipmentsByPagination({})
      } catch (error) {
        if (!this.$store.state.filial) {
          this.errorMessage('Erro ao salvar Equipamento, selecione uma filial.')
          return
        }
        this.errorMessage(
          `Erro ao salvar Equipamento: ${error.response.data.error.message}`
        )
      } finally {
        this.isLoading = false
      }
    },
    async remove(id) {
      this.isLoading = true
      try {
        await EquipmentService.remove(id)

        this.successMessage('Removido com sucesso')
        await this.loadEquipmentsByPagination({})
      } catch (error) {
        this.errorMessage(
          `Erro ao remover Equipamento: ${error.response.data.error.message}`
        )
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
<style src="../style.scss" lang="scss"></style>
